// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"35528b56bf5f4d59521b","418":"007abf10fb33d94d34ac","661":"79feb46d0f08a91d51a6"}[chunkId] + ".bundle.js";
};